const ReactDOM   = require("react-dom/client");

import {cs}        from "@Common/react/chain-services";
import {fragments} from "@Common/react/fragments";
import {Invoke}    from "@Common/react/invoke";

const {loadCss} = require("./load-css");

export const bootstrap = ({next}) => cs(

    ["dom", (_, next) => {
        if (window["qaTagsViewer"]) {
            window["qaTagsViewer"].destroy();
            // return;
        }

        const dom = document.createElement("div");
        dom.className = "qa-tags-viewer-9di";
        dom.setAttribute("data-key", ""+Date.now());
        document.body.appendChild(dom);

        return next(dom);
    }],
    ["indexScript", ({}, next) => next(document.currentScript ?? Array.from(document.scripts).find(script => script.src.includes('/xadmin/index.js')))],
    ["styleDom", ({indexScript}, next) => (() => {
        next(
            loadCss(indexScript["src"].replace(/\.js\b/, ".css"))
        );
    })()],
    ["reactRoot", ({dom}, next) => {
        const root = ReactDOM.createRoot(dom);
        root.render(next(root));
    }],
    ({dom, styleDom, reactRoot}) => fragments(
        Invoke({
            action: () => {
                window["qaTagsViewer"] = {
                    destroy: () => {
                        reactRoot.unmount();
                        styleDom?.remove();
                        dom.remove();
                        delete window["qaTagsViewer"];
                    },
                };
            },
        }),
        next(),
    ),
);
